const normalizeLineBreaks = text => text.replace(/\r?\n/g, '\n');
const splitToLines = text => normalizeLineBreaks(text).split('\n');

export default splitToLines;
